
<div class="nudge-block flex-centered-container-vr padding margin-bottom widget-box-shadow chamfer" 
 [ngClass]="[ nudgeConfiguration?.type]">
    <div class=" flex-centered-container">
        <div class="margin-4-bottom nudge-icon"></div>
        <span class="nudge-heading font-14 font-500" [innerHTML]="message">
            
        </span>
    </div>
</div>
